var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoExiros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 752 165.299",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil0 {fill:#0C479D}\r\n    .fil1 {fill:#484848}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2375808070560"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M64.08 29.259c22.861,0 26.656,18.075 26.656,38.652l-52.046 0c0.185,-15.561 6.943,-38.652 25.39,-38.652zm55.979 93.298c-11.93,6.046 -28.981,14.911 -52.909,11.64 -20.187,-3.226 -28.414,-21.449 -28.394,-40.963l90.632 0c0,-35.182 -3.88,-79.871 -45.073,-90.874 -40.497,-10.817 -69.748,17.05 -80.723,53.045 -9.338,30.626 -1.012,84.229 31.405,100.233 32.007,15.802 79.19,2.081 87.446,-1.251l-2.384 -31.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M649.192 123.889l-1.718 33.062c25.545,6.089 52.824,13.561 78.345,0.915 22.459,-11.128 34.655,-41.432 19.387,-62.016 -11.968,-16.136 -38.438,-25.537 -52.401,-38.233 -11.194,-10.178 -6.527,-23.789 7.198,-25.533 13.725,-1.745 27.753,2.058 39.821,6.505l1.819 -31.317c-49.598,-21.844 -116.391,11.139 -89.38,58.9 13.72,24.261 45.499,29.059 57.209,44.119 11.797,15.173 -5.169,24.054 -18.998,24.239 -16.063,-0.468 -29.073,-7.205 -41.282,-10.641z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M428.83 26.535l-1.018 -23.943 -35.721 0.01 0 159.939 39.85 0 -0.017 -82.651c-0.231,-35.277 9.379,-41.301 42.667,-41.301l0 -37.319c-26.041,0 -36.218,5.743 -45.761,25.265z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "306.655,162.541 345.307,162.541 345.307,2.603 306.655,2.603 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "194.531,82.796 240.542,162.976 278.998,162.541 238.333,82.579 278.665,2.602 240.013,2.602 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "221.618,82.683 180.805,2.189 142.05,2.602 182.874,82.718 142.717,162.541 180.036,162.541 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M555.009 0.388c48.559,0 68.375,36.917 68.375,82.455 0,45.539 -17.417,82.456 -68.375,82.456 -50.957,0 -68.374,-36.917 -68.374,-82.456 0,-45.538 19.816,-82.455 68.374,-82.455zm0 27.214c21.244,0 30.488,24.823 30.488,55.444 0,30.621 -9.844,55.444 -30.488,55.444 -20.644,0 -30.388,-24.823 -30.388,-55.444 0,-30.621 9.144,-55.444 30.388,-55.444z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExiros);
export default __webpack_public_path__ + "static/media/logo_exiros.5c3f3c6e0bad935096c24c35e0da5fa4.svg";
export { ForwardRef as ReactComponent };